import StatsWidgets from '@rio-cloud/rio-uikit/StatsWidgets';
import StatsWidget from '@rio-cloud/rio-uikit/StatsWidget';
import styles from './ContractTimeCard.module.css'

interface ContractTimeCardProps {
    score: number | undefined;
    maxScore: number | undefined;
    status: string | undefined;
}

export function ContractTimeCard({ score = 0, maxScore = 0, status = 'RECENTE' }: ContractTimeCardProps) {


    const setMessage = () => {
        if (status === 'VETERANO') {
            return (
                <div className='margin-top-20'>
                    Parceiro de longa data! Você atingiu o <span className='text-bold'>teto de pontuação</span> por fidelidade.
                </div>
            )
        } else if (status === 'INTERMEDIARIO' || status === 'CONSOLIDADO') {
            return (
                <div className='margin-top-20'>
                    <div>Sua pontuação cresce <span className='text-bold'>conforme o tempo de parceria aumenta</span>.</div>
                </div>
            )
        } else if (status === 'RECENTE') {
            return (
                <div className='margin-top-20'>
                    <div>Bem-vindo! Sua pontuação de tempo começará a ser contabilizada <span className='text-bold'>em breve</span>.</div>
                </div>
            )
        } else{

        }
    }

    return (
        <StatsWidgets>
            <StatsWidget className='shadow-default' style={{ height: 250 }}>
                <StatsWidget.Header>Tempo de Relacionamento</StatsWidget.Header>
                <StatsWidget.Body className='padding-20'>
                    <div className={styles['score-container']}>
                        <div className='text-center'>
                            <div>
                                <div style={{ fontSize: 40 }}>
                                    <span className={styles["current-score"]}>{score}</span>
                                    <span className={styles["total-score"]}>/ {maxScore}</span>
                                </div>
                                {score === maxScore ? (
                                    <div className='margin-top-10'>
                                        <div className="label text-size-12 label-success">
                                            Pontuação Máxima! <span className='rioglyph rioglyph-trophy'></span>
                                        </div>
                                    </div>
                                ) : (
                                    null
                                )}
                            </div>
                        </div>
                        <div>
                            {setMessage()}
                        </div>
                    </div>
                </StatsWidget.Body>
            </StatsWidget>
        </StatsWidgets>
    );
}